import { atom, RecoilState, selector } from "recoil";
import { AccountDetails } from "../Component/Model/SignIn";
import { RolesAtoms } from "./Roles.Atom";
import { recoilPersist } from "recoil-persist";

const { persistAtom } = recoilPersist();
export const UserAtom: RecoilState<AccountDetails> = atom<AccountDetails>({
    key: 'UserAtom',
    default: {
        contactName: "",
        email: "",
        telephone: "",
        username: "",
        sendMeEmail: false,
        changeUsername: false,
        isAdmin: false,
        isSubAdmin: false,
        hasAuditRole: false,
        isInternalAuditor: false,
        isClient: false,
        isClientAdmin: false,
        isSiteAdministration: false,
        isScorecardAdmin: false,
        registrationId: "",
        isFirstTimeLogin: false,
        hasWSPScorecards: false,
        verificationAgencyBanner: "",
        hideVerificationHubModal: false,
        isAPIRegistration: false,
        isVAUser: false,
        enablePayrollIntegration: false,
        roles: []
    } as AccountDetails,
    effects_UNSTABLE : [persistAtom]
});

export const userRolesState = selector<string[]>({
    key: 'user_roles_selector',
    get: ({ get }) => {
        const roles = get(RolesAtoms);
        if (roles.length === 0) {
            return [];
        }

        return roles;
    }
}); 

export const userRegistrationIdState = selector<string>({
    key: 'user_registrationId_selector',
    get: ({get}) => {
        const registrationId = get(UserAtom).registrationId;
        return registrationId ?? '';
    }
})